import { useCallback, useContext, useEffect } from "react";

import { ActivityLevels } from "@/constants/activityLevel";
import { FitnessGoals } from "@/constants/fitnessGoal";
import { FitnessLevels } from "@/constants/fitnessLevels";
import { QUESTIONS_IDS } from "@/constants/questionsIds";
import { EventAnswers, PaceAnswers } from "@/types/answers";

import { Answers, AnswersContext } from "./AnswersProvider";
import { localStorageManager, LocalStorageManagerKeys } from "./localStorageManager";

type ValuesTypes = {
    [QUESTIONS_IDS.PRIMARY_GOAL]: FitnessGoals;
    [QUESTIONS_IDS.AGE]: number;
    [QUESTIONS_IDS.FITNESS_LEVEL]: FitnessLevels;
    [QUESTIONS_IDS.EVENT_MOTIVATION]: EventAnswers;
    [QUESTIONS_IDS.WEB_CYCLE]: string;
    [QUESTIONS_IDS.WEB_REPRODUCTIVE_STAGE]: string;
    [QUESTIONS_IDS.LOCATION]: string | string[];
    [QUESTIONS_IDS.PLAN_FAILED]: string;
    [QUESTIONS_IDS.CURRENT_WEIGHT]: number;
    [QUESTIONS_IDS.TARGET_WEIGHT]: number;
    [QUESTIONS_IDS.PACE]: PaceAnswers;
    [QUESTIONS_IDS.FIRST_WEIGHT_PRREDICT_DATE]: Date;
    [QUESTIONS_IDS.WEIGHT_LOSS_GOAL]: string;
    [QUESTIONS_IDS.EVENT_DATE]: Date | "skip";
    [QUESTIONS_IDS.INTERESTS]: string;
    [QUESTIONS_IDS.ABILITY_TO_STAY_MOTIVATED]: string;
    [QUESTIONS_IDS.DESIRED_BODY]: string;
    [QUESTIONS_IDS.WEIGHT_PRREDICT_DATE]: Date;
    [QUESTIONS_IDS.INTERMEDIATE_WEIGHT_LOSS]: number;
    [QUESTIONS_IDS.INTERMEDIATE_WEIGHT_LOSS_DATE]: string;
    [QUESTIONS_IDS.SHOW_INTERMEDIATE_RESULT]: boolean;
    [QUESTIONS_IDS.ACTIVITY_LEVEL]: ActivityLevels;
};

const useAnswers = () => {
    const { answers, ...rest } = useContext(AnswersContext);

    const getAnswersValue = useCallback(
        // TODO: remove when move all QUESTIONS_IDS to ValueTypes
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        <T extends QUESTIONS_IDS>(questionId: T): ValuesTypes[T] => {
            // TODO: remove when move all QUESTIONS_IDS to ValueTypes
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return answers[questionId] as ValuesTypes[T];
        },
        [answers]
    );

    return {
        answers,
        getAnswersValue,
        ...rest,
    };
};

export const useStorageAnswers = () => {
    const { setAnswers } = useAnswers();

    useEffect(() => {
        const savedAnswers = localStorageManager.getStoredItem(
            LocalStorageManagerKeys.ANSWERS
        ) as Answers;

        if (savedAnswers) {
            setAnswers(savedAnswers);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useAnswers;
